import zh from './package/zh.js'
import en from './package/en.js'
export default {
  zh: zh, // 中文
  en: en // 英文
}
